import { defineMessages } from 'react-intl';
import { bitbucketWorkspaceSelectorMessages as sharedMessages } from '../../MCP/BitbucketWorkspaceSelector/messages';

/**
 * Only the messages this flow adds or rewords are declared here; the rest are
 * reused from the default flow so each id is declared once and keeps its
 * translations. `defineMessages` is what the formatjs extractor reads, so
 * spreading the shared object below does not re-extract those ids.
 *
 * The reworded copy takes new ids rather than editing the default flow's, so
 * both flows can run at once without one changing the other's strings.
 */
const optionalSitesMessages = defineMessages({
  placeholder: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.placeholder.workspace',
    defaultMessage: 'Select',
    description: 'Placeholder text inside the Bitbucket workspace picker',
  },
  noPermissions: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.noPermissions',
    defaultMessage:
      'No permissions are available for the selected workspace. Select a different workspace to continue.',
    description:
      'Message below the Bitbucket workspace picker when the permission check succeeded but returned no permissions',
  },
});

export const bitbucketWorkspaceSelectorMessages = {
  ...sharedMessages,
  ...optionalSitesMessages,
};
